'use client';

import { useEffect } from 'react';

/**
 * While a planner sheet or list is open, mark <body> so floating chrome (the
 * chat bubble) steps aside instead of covering rows and buttons. Counted, so
 * two open sheets don't un-hide it when the first one closes.
 */
export function useSheetOpen(active = true): void {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return;
    const b = document.body;
    const n = Number(b.dataset.tpSheets || '0') + 1;
    b.dataset.tpSheets = String(n);
    return () => {
      const m = Number(b.dataset.tpSheets || '1') - 1;
      if (m <= 0) delete b.dataset.tpSheets;
      else b.dataset.tpSheets = String(m);
    };
  }, [active]);
}
